const catalogOrder = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base",
});

export function sortQuoteLines<T extends { catalogNumber?: string | null }>(
  lines: readonly T[],
): T[] {
  return [...lines].sort((a, b) => {
    const left = (a.catalogNumber ?? "").normalize("NFKC").trim();
    const right = (b.catalogNumber ?? "").normalize("NFKC").trim();
    if (!left || !right) return left ? -1 : right ? 1 : 0;
    return catalogOrder.compare(left, right);
  });
}
